// Libraries
import { CloseIcon } from '@chakra-ui/icons';
import { Flex, IconButton, Text } from '@chakra-ui/react';
import { Fragment } from 'react';
// Components
import { BackContinueFooter } from '@molecules/index';
// Utils
import text from '@translations/en.json';
// Types
import { ConfirmationModalProps } from './ConfirmationModal.types';

/**
 * ConfirmationModal component represents a modal for confirmation.
 *
 * @component
 * @param {ConfirmationModalProps} props - The component props.
 * @param {Function} props.closeModal - The function to close the modal.
 * @param {Function} props.onCancel - The function to handle the cancellation action.
 * @param {Function} props.onContinue - The function to handle the continue action.
 * @returns {ReactElement} The ConfirmationModal component.
 */
export const ConfirmationModal = ({
  closeModal,
  onCancel,
  onContinue,
  continueLabel = text.delete,
  modalTitle,
  children,
  isLoading,
}: ConfirmationModalProps) => {
  return (
    <Fragment>
      <IconButton
        position='absolute'
        top={2.5}
        right={2.5}
        h={8}
        minW={8}
        aria-label={text.close_menu}
        variant='baseLight'
        icon={<CloseIcon color='text.faded' />}
        onClick={closeModal}
      />
      <Flex minH={8} align='center'>
        <Text fontSize='l' color='text.base' fontWeight='medium'>
          {modalTitle}
        </Text>
      </Flex>
      {children}
      <BackContinueFooter
        backText='Cancel'
        onBack={onCancel}
        continueText={continueLabel}
        onContinue={onContinue}
        continueVariant='warning'
        isLoading={isLoading}
      />
    </Fragment>
  );
};
